import React, { useState, useEffect, useCallback } from "react";
import "../../assets/styles/local/AddDocumentsWithPagination.css";
import CardAddButton from "../../assets/icons/CardAddButton.svg";
import lockGrey from "../../assets/icons/lockGrey.svg";
import lockBlue from "../../assets/icons/lockBlue.svg";
import DeleteIcon from "../../assets/icons/DeleteIcon.svg";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { API_URL } from "../../redux/constants/type";
import roundFileSize from "../../utils/Documents/roundFileSize";
import moment from "moment";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import { handleGeneralNotification } from "../../utils/helpers/notifications";
import {
  AddDocumentToProductPart,
  DeleteProductDocument,
  EmptyProductPart,
  UpdateIslocked,
} from "../../redux/actions/action";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import DeletePopUp from "../Dailogs/DeletePopUp";
import { EyeOutlined } from "@ant-design/icons";
import { getFilePreview } from "../../utils/filePreview/filePreview";
import FilePreviewModal from "../../utils/filePreview/FilePreviewModal";
import DocumentUploaderWithProgress from "../Common/Document_Uploader_With_Progress";

const StockDocumentsTab = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const productPartId = location?.state?.productPartId;
  const userId = window.localStorage.getItem("userid");
  const roleId = window.localStorage.getItem("roleid");
  const userFirstName = window.localStorage.getItem("firstname");
  const userLastName = window.localStorage.getItem("lastname");

  const [filePreview, setFilePreview] = useState(null);

  const [deleteDocument, setDeleteDocument] = useState(false);
  const [deleteRowData, setDeleteRowData] = useState(null);
  const [newDoc, setNewDoc] = useState([]);

  const addProductPartData = useSelector((state) => state.user.addProductPart);
  const updateProductPartData = useSelector(
    (state) => state.user.updateProductPart,
  );
  const fetchDocumentByProductPartIdData = useSelector(
    (state) => state.user.fetchDocumentByProductPartId,
  );

  const [paginationObj, setPaginationObj] = useState({
    totalRecords: 0,
    currentPage: 0,
    startRecordIndex: 0,
    endRecordIndex: 0,
    totalPages: 0,
    records: [],
  });
  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Add Products and Parts").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  useEffect(() => {
    if (fetchDocumentByProductPartIdData?.status === true) {
      setNewDoc(fetchDocumentByProductPartIdData?.data);
    }
  }, [fetchDocumentByProductPartIdData]);

  const calculatePagination = useCallback(
    (pageNumber) => {
      const records = newDoc || [];
      const startRecordIndex = Math.max(10 * pageNumber - 9, 1);
      const endRecordIndex = Math.min(10 * pageNumber, records.length);
      const tempPaginationObj = {
        totalRecords: records.length,
        currentPage: pageNumber,
        startRecordIndex,
        endRecordIndex,
        totalPages: Math.ceil(records.length / 10),
        records: records.slice(startRecordIndex - 1, endRecordIndex),
      };
      setPaginationObj({ ...tempPaginationObj });
    },
    [newDoc],
  );

  useEffect(() => {
    calculatePagination(1);
  }, [calculatePagination, newDoc]);

  const onFileUploaded = (data) => {
    // const newDocument = {
    //   documentname: data[0].name,
    //   documentextension: data[0].type,
    //   documentcontent: "string",
    //   link: data[0].link,
    //   documentsize: data[0].size,
    //   islocked: 0,
    //   uploadedbyfirstname: userFirstName,
    //   uploadedbylastname: userLastName,
    //   userId: userId,
    // };

    // setNewDoc((prevFileList) => [...prevFileList, newDocument]);

    const newDocuments = data.map((file) => ({
      documentname: file.name,
      documentextension: file.type,
      documentcontent: "string",
      link: file.link,
      documentsize: file.size,
      islocked: 0,
      uploadedbyfirstname: userFirstName,
      uploadedbylastname: userLastName,
      userId: userId,
    }));

    setNewDoc((prevFileList) => [...prevFileList, ...newDocuments]);
  };

  const fileValidationBeforeUpload = (file) => {
    let isValid = true;
    // Check if the document with the same name already exists
    if (newDoc.some((doc) => doc.documentname === file.name)) {
      handleGeneralNotification(
        {
          notificationType: "CUSTOM",
          text: "Document with the same name already exists.",
        },
        false,
      );
      isValid = false;
    }
    return isValid;
  };

  const handleDeleteDocumentFun = () => {
    const updatedFileList = newDoc.filter(
      (item) => item.documentname !== deleteRowData.documentname,
    );
    setNewDoc(updatedFileList);
    if (productPartId) {
      const payload = {
        documentid: deleteRowData.documentid,
      };
      dispatch(DeleteProductDocument(payload));
    }
    setDeleteDocument(false);
    setDeleteRowData(null);
  };

  const [addTimeDltDocumentPopup, setAddTimeDltDocumentPopup] = useState(false);
  const [addTimeDeletePayload, setAddTimeDeletePayload] = useState(null);

  const handleDeleteDocumentFun2 = () => {
    console.log("asc23");
    let data = [...newDoc];
    data.splice(addTimeDeletePayload.index, 1);
    setNewDoc(data);

    setAddTimeDltDocumentPopup(false);
    setAddTimeDeletePayload(null);
  };

  const lockDocument = (item) => {
    const updatedFileList = newDoc.map((file) =>
      file.documentid === item.documentid
        ? { ...file, islocked: file.islocked ? 0 : 1 }
        : file,
    );
    setNewDoc(updatedFileList);
    if (productPartId) {
      const payload = {
        documentid: item.documentid,
        islocked: item.islocked ? 0 : 1,
      };
      dispatch(UpdateIslocked(payload));
    }
  };

  useEffect(() => {
    if (
      (addProductPartData.status === true &&
        addProductPartData?.data &&
        newDoc.length) ||
      (updateProductPartData.status === true &&
        updateProductPartData?.data &&
        newDoc.length)
    ) {
      const payload = {
        userid: userId,
        productpartid: productPartId
          ? productPartId
          : addProductPartData?.data?.productPartid,
        productpartdocs: newDoc.filter((data) => data?.link),
      };
      dispatch(AddDocumentToProductPart(payload));
      history.push("/productsList");
      dispatch(EmptyProductPart());
    }
  }, [
    addProductPartData?.data,
    addProductPartData.status,
    productPartId,
    updateProductPartData?.data,
    updateProductPartData.status,
    userId,
  ]);

  useEffect(() => {
    if (
      addProductPartData.status === true ||
      updateProductPartData.status === true
    ) {
      if (!newDoc.length > 0) {
        history.push("/productsList");
        dispatch(EmptyProductPart());
      }
    }
  }, [addProductPartData, updateProductPartData]);

  const pdfDownload = (event, documentid, documentname, link) => {
    if (documentid) {
      axios({
        method: "post",
        url: `${API_URL}/api/Files/DownloadToS3?documentid=` + documentid,
        responseType: "blob",
        headers: {
          "Content-Type": "application/json",
        },
        // data: {
        //   message?.message
        // },
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        // var el = document.createElement('div');
        const document = window.document || {};
        const link = document.createElement("a");
        link.href = url;
        link.download = documentname;
        document.body.appendChild(link);
        link.click();
        // link.setAttribute("download", `FinalDocument.pdf`);

        // Append to html link element page
        // document.body.appendChild(link);

        // Start download
        // link.click();

        // Clean up and remove the link
        // link.parentNode.removeChild(link);
        // return docFileDownload;
        // }, 1000)
      });
    } else {
      const url = window.URL.createObjectURL(new Blob([link]));
      document = window.document || {};
      const link = document.createElement("a");
      link.href = url;
      link.download = documentname;
      document.body.appendChild(link);
      link.click();
    }
  };
  const renderDocumentRows = () => {
    return newDoc.map((item, index) => (
      <tbody key={index} style={{ borderBottom: "0.5px dashed #A5A5A5" }}>
        <tr className="products-and-parts-actionGap">
          <td className="d-flex gap-3">
            <img
              className={"products-and-parts-dltIcon"}
              style={{
                cursor:
                  item?.userId === userId ||
                  item?.islockedby?.userid === userId ||
                  roleId === process.env.REACT_APP_IS_OWNER
                    ? item.islocked
                      ? "not-allowed"
                      : "pointer"
                    : "not-allowed",
                opacity: item.islocked ? "0.5" : "1",
              }}
              src={DeleteIcon}
              alt=""
              onClick={() => {
                if (item?.documentid) {
                  if (
                    !item.islocked &&
                    (item.userId === userId ||
                      item.islockedby.userid === userId ||
                      roleId === process.env.REACT_APP_IS_OWNER)
                  ) {
                    setDeleteRowData(item);
                    setDeleteDocument(true);
                  }
                } else {
                  // let data = [...newDoc];
                  // data.splice(index, 1);
                  // setNewDoc(data);

                  setAddTimeDeletePayload({
                    documentid: item?.documentid,
                    index: index,
                  });
                  setAddTimeDltDocumentPopup(true);
                }
              }}
            />
            <img
              style={{
                cursor:
                  item.userId === userId ||
                  item.islockedby.userid === userId ||
                  roleId === process.env.REACT_APP_IS_OWNER
                    ? "pointer "
                    : "not-allowed",
                display: !item?.documentid && "none",
              }}
              className="products-and-parts-dltIcon"
              src={item.islocked ? lockBlue : lockGrey}
              alt=""
              onClick={() => {
                if (
                  item.userId === userId ||
                  item.islockedby.userid === userId ||
                  roleId === process.env.REACT_APP_IS_OWNER
                ) {
                  lockDocument(item);
                }
              }}
            />
          </td>

          <td
            onClick={(event) =>
              pdfDownload(
                event,
                item?.documentid,
                item.documentname,
                item?.link,
              )
            }
            className="products-and-parts-documntName"
            style={{ textDecoration: "underline", cursor: "pointer" }}
          >
            {item.documentname}
          </td>

          <td className="products-and-parts-documntName">
            {roundFileSize(item.documentsize)}
          </td>

          <td className="products-and-parts-documntName">
            {moment(item.documentDate).format("DD.MM.YYYY")}
          </td>

          <td className="ps-3">
            {item.uploadedbyfirstname + " " + item.uploadedbylastname}
          </td>

          <td className="pointer">
            <EyeOutlined
              onClick={() => {
                setFilePreview(
                  getFilePreview({
                    // file: file, // local upload file
                    url: item.link,
                    type: item.link.split(".").pop(),
                    name: item.documentname,
                  }),
                );
              }}
            />
          </td>
        </tr>
      </tbody>
    ));
  };

  return (
    <>
      <div className="container-fluid ps-5 products-and-parts-add-doc-with-pagination-container">
        <DocumentUploaderWithProgress
          maxSizeInMb={100}
          onUploaded={onFileUploaded}
          multiple={true}
          beforeFileUpload={fileValidationBeforeUpload}
        >
          <div className="d-flex gap-2 pointer ps-2">
            <img
              src={CardAddButton}
              className="products-and-parts-addDocImg"
              alt=""
            />
            <p className="pt-1 products-and-parts-addDocText">
              {/* Add Document */}
              {t("Add Document")}
            </p>
          </div>
        </DocumentUploaderWithProgress>

        <div className="products-and-parts-custom-pagination">
          <div className="range-text">
            {`${paginationObj.startRecordIndex} - ${paginationObj.endRecordIndex} of ${paginationObj.totalRecords}`}
          </div>
          <div className="products-and-parts-pagination-buttons">
            <div
              className={`products-and-parts-pagination-button ${
                paginationObj.currentPage === 1 ? "disabled" : ""
              }`}
            >
              <BsChevronLeft />
            </div>
            <div className="pagination-current-page">
              {paginationObj.currentPage}
            </div>
            <div
              className={`products-and-parts-pagination-button ${
                paginationObj.totalPages === 0 ||
                paginationObj.totalPages === paginationObj.currentPage
                  ? "disabled"
                  : ""
              }`}
            >
              <BsChevronRight />
            </div>
          </div>
        </div>
      </div>

      <table className="table table-borderless">
        <thead>
          <tr
            className="products-and-parts-textHeadings"
            style={{ borderBottom: "1px solid #A5A5A5" }}
          >
            <th scope="col products-and-parts-actionGap">
              {/* Actions */}
              {t("Actions")}
            </th>
            <th scope="col products-and-parts-documentGap">
              {/* Document Name */}
              {t("Document Name")}
            </th>
            <th scope="col">
              {/* Size */}
              {t("Size")}
            </th>
            <th scope="col">
              {/* Date */}
              {t("Date")}
            </th>
            <th scope="col">
              {/* Uploaded by */}
              {t("Uploaded by")}
            </th>
            <th></th>
          </tr>
        </thead>
        {renderDocumentRows()}
      </table>

      <FilePreviewModal
        open={filePreview}
        file={filePreview}
        onClose={() => setFilePreview(null)}
      />

      {deleteDocument && (
        <DeletePopUp
          animation={true}
          handleDelete={handleDeleteDocumentFun}
          show={deleteDocument}
          onHide={() => setDeleteDocument(false)}
          title1={"This data will be removed from the system"}
          title2={"and cannot be undone."}
          title3={"Do you want to proceed?"}
          no={"No"}
          yes={"Yes"}
        />
      )}

      {addTimeDltDocumentPopup && (
        <DeletePopUp
          animation={true}
          handleDelete={handleDeleteDocumentFun2}
          show={addTimeDltDocumentPopup}
          onHide={() => setAddTimeDltDocumentPopup(false)}
          title1={"This data will be removed from the system"}
          title2={"and cannot be undone."}
          title3={"Do you want to proceed?"}
          no={"No"}
          yes={"Yes"}
        />
      )}
    </>
  );
};

export default StockDocumentsTab;
